import { CalendarDays, Hourglass, Users, CheckCheck } from "lucide-react";

const ITEMS = [
  ["total", "Total appointments", Users],
  ["pending", "Pending confirmation", Hourglass],
  ["today", "Today's visits", CalendarDays],
  ["completed_today", "Completed today", CheckCheck],
];

export const StatsCards = ({ stats }) => (
  <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
    {ITEMS.map(([key, label, Icon], i) => (
      <div key={key} className={`rounded-2xl p-5 border ${i === 1 ? "bg-primary text-white border-primary" : "bg-white border-slate-100"}`} data-testid={`stat-${key}`}>
        <Icon className={`h-5 w-5 ${i === 1 ? "text-white/80" : "text-secondary"}`} />
        <p className="mt-4 text-3xl font-display font-bold" data-testid={`stat-${key}-value`}>{stats?.[key] ?? "–"}</p>
        <p className={`mt-1 text-sm ${i === 1 ? "text-white/70" : "text-muted-foreground"}`}>{label}</p>
      </div>
    ))}
  </div>
);
